import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.css']
})
export class BrandsComponent implements OnInit {

  constructor(private brandService:ServiceService,private route: ActivatedRoute, private router: Router) { }
 
 // brandUrl='http://192.241.151.66:5000/viewBrands'
  imgUrl=this.brandService.ReturnBase();
  output:any=[]
  count=0
  loaderShown=true;
  CardShown=false;

   //------function for routing-----------
   BrandDetails(){
    this.router.navigateByUrl(('admin/brand-details'));  
  }
  //------routing to edit page--------------------
  EditBrands(){
    this.router.navigateByUrl(('admin/edit-brand'));  
  }
  
  //--------function which give id of selected customer---------
  getValue = (item : string) =>{
     
    this.brandService.setBrandId(item)
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  
  }
  //function for going to next page
  clicks_next(){
   
    this.count=this.count+1;
    //-------api get()calling for next page-------------
    this.brandService.ViewBrandPage('?offset='+this.count+'&limit=20').subscribe((res)=>{
    this.output=res.data
    })
  
  }
  
  //function for going to previous page
  clicks_previous(){
   
    this.count=this.count-1;
    if(this.count<0)
    {
      this.count=0
    }
    //-------api get()calling for previous page-------------
    this.brandService.ViewBrandPage('?offset='+this.count+'&limit=20').subscribe((res)=>{
    this.output=res.data
    })
  
  }
  ngOnInit(): void {
    this.brandService.ViewBrand().subscribe((res)=>{
    this.output=res.data
    this.loaderShown=false;
    this.CardShown=true;
    })
  }

}
